import type { TagRow } from '../../../types'

// Collect the complete key/value rows into the comma-join-ready `key:value`
// pairs the tags query param expects (see useConfigs). Rows missing a key or a
// value are ignored so a half-typed row never narrows the list.
export function collectPairs(rows: TagRow[]): string[] {
  return rows
    .map(({ key, value }) => ({ key: key.trim(), value: value.trim() }))
    .filter(({ key, value }) => key && value)
    .map(({ key, value }) => `${key}:${value}`)
}
